export function clamp100(n) {
  const v = Number.isFinite(n) ? n : 0
  return Math.max(0, Math.min(100, v))
}
